// Core
import { localiseString } from "./localiseString"

function getSingleListItem(block, interviewSequence) {
  let { __typename } = block,
    { contentful_id } = block

  let titleOverride = block.menuTitle,
    anchorOverride = titleOverride
      ? titleOverride.replace(/\s+/g, "-").toLowerCase()
      : null

  if (
    !titleOverride &&
    __typename === "ContentfulInterview" &&
    interviewSequence
  )
    return

  switch (__typename) {
    case "ContentfulEssay":
      return {
        id: contentful_id,
        title: titleOverride ? titleOverride : localiseString("Essay"),
        anchorTarget: `#ep-${anchorOverride ? anchorOverride : "essay"}`,
      }
    case "ContentfulImageGallery":
      return {
        id: contentful_id,
        title: titleOverride ? titleOverride : localiseString("Gallery"),
        anchorTarget: `#ep-${anchorOverride ? anchorOverride : "gallery"}`,
      }
    case "ContentfulInterview":
      return {
        id: contentful_id,
        title: titleOverride ? titleOverride : localiseString("Interview"),
        anchorTarget: `#ep-${anchorOverride ? anchorOverride : "interview"}`,
      }
    case "ContentfulPerformanceIntro":
      return {
        id: contentful_id,
        title: titleOverride ? titleOverride : localiseString("Performance"),
        anchorTarget: `#ep-${anchorOverride ? anchorOverride : "hero"}`,
      }
    case "ContentfulPlaylist":
      return {
        id: contentful_id,
        title: titleOverride ? titleOverride : localiseString("Playlist"),
        anchorTarget: `#ep-${anchorOverride ? anchorOverride : "playlist"}`,
      }
    case "ContentfulProgramNotes":
      return {
        id: contentful_id,
        title: titleOverride ? titleOverride : localiseString("Program Notes"),
        anchorTarget: `#ep-${
          anchorOverride ? anchorOverride : "program-notes"
        }`,
      }
    case "ContentfulVideoGallery":
      return {
        id: contentful_id,
        title: titleOverride ? titleOverride : localiseString("Extras"),
        anchorTarget: `#ep-${anchorOverride ? anchorOverride : "extras"}`,
      }
    case "ContentfulWrittenInterview":
      return {
        id: contentful_id,
        title: titleOverride ? titleOverride : localiseString("Interview"),
        anchorTarget: `#ep-${
          anchorOverride ? anchorOverride : "written-interview"
        }`,
      }
    default:
      return null
  }
}

function blockList(blocks) {
  let listItems = [],
    interviewSequence = false

  if (blocks === null) {
    return listItems
  }

  blocks.forEach(block => {
    listItems.push(getSingleListItem(block, interviewSequence))

    interviewSequence = block.__typename === "ContentfulInterview"
  })

  return listItems
}

export { blockList }
